export const getStoreUtmsAndGclidValue = () => {
    const cookies = document.cookie.split('; ');
    const ga = cookies.filter((cookie) => cookie.includes('_ga='));

    if (typeof window === 'undefined') {
        return {
            gaClid: null,
            storeGclid: null,
            storeUtms: null,
            utmSource: null,
        };
    }

    const urlParams = new URLSearchParams(window.location.search);

    const utmParams: Record<string, string> = {};
    const utmKeys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'utm_id'];

    utmKeys.forEach((key) => {
        const value = urlParams.get(key);
        if (value) {
            utmParams[key] = value;
        }
    });

    const gclid = urlParams.get('gclid');
    const utmSource = urlParams.get('utm_source');

    const storeUtms = Object.keys(utmParams).length > 0 ? JSON.stringify(utmParams) : null;

    return {
        gaClid: ga.length ? ga[0].replace('_ga=', '') : null,
        storeGclid: gclid,
        storeUtms: storeUtms,
        utmSource: utmSource,
    };
};
